<template>
  <div>
    <MalformedCodesAlert
      v-if="malformedRows.length > 0"
      :rows="malformedRows"
      class="ignored-rows__malformed"
    />

    <!-- Information, not an error: closed by default. `table-wrapper` gives the
         table the theme's dark rows, as elsewhere. -->
    <el-collapse class="table-wrapper">
      <el-collapse-item name="ignoredRows">
        <template slot="title">
          {{ $tc(`${I18N}.title`, rows.length) }} ({{ reasonCounts }})
        </template>
        <el-table
          :data="sortedRows"
          :max-height="300"
        >
          <el-table-column
            prop="sourceRow"
            :label="$t(`${I18N}.columns.sourceRow`)"
            width="100"
          />
          <el-table-column :label="$t(`${I18N}.columns.label`)">
            <FileLabel
              slot-scope="{ row }"
              :label="row.label"
            />
          </el-table-column>
          <el-table-column
            column-key="reason"
            :label="$t(`${I18N}.columns.reason`)"
            :filters="reasonFilters"
            :filter-method="hasReason"
          >
            <template slot-scope="{ row }">
              <i
                v-if="isMalformedSampleCode(row)"
                class="el-icon-warning-outline"
                aria-hidden="true"
              />
              {{ reasonText(row) }}
            </template>
          </el-table-column>
        </el-table>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
  import FileLabel from './FileLabel.vue';
  import MalformedCodesAlert from './MalformedCodesAlert.vue';
  import {
    countIgnoredRowReasons,
    ignoredRowReasonKey,
    isMalformedSampleCode,
    malformedCodeIssue,
    sortBySourceRow,
  } from './labelIssues';

  // Rows left out of the import (REQ-07), on steps 1 to 3. Malformed sample
  // codes are signalled above the panel (C53).
  export default {
    name: 'IgnoredRowsSummary',
    components: { FileLabel, MalformedCodesAlert },
    props: {
      rows: { type: Array, required: true },
    },
    data() {
      return {
        I18N: 'analysesData.importValues.ignoredRows',
      };
    },
    computed: {
      sortedRows() {
        return sortBySourceRow(this.rows);
      },
      malformedRows() {
        return this.rows.filter(isMalformedSampleCode);
      },
      reasonCounts() {
        return countIgnoredRowReasons(this.rows)
          .map(({ reasonKey, count }) =>
            this.$t(`${this.I18N}.reasonCount`, {
              reason: this.$t(reasonKey),
              count,
            })
          )
          .join(', ');
      },
      reasonFilters() {
        return countIgnoredRowReasons(this.rows).map(({ reasonKey }) => ({
          text: this.$t(reasonKey),
          value: reasonKey,
        }));
      },
    },
    methods: {
      isMalformedSampleCode,
      reasonText(row) {
        const reason = this.$t(ignoredRowReasonKey(row.reason));
        return isMalformedSampleCode(row)
          ? this.$t(`${this.I18N}.malformedReason`, {
              reason,
              issue: this.$t(malformedCodeIssue(row).titleKey),
            })
          : reason;
      },
      hasReason(reasonKey, row) {
        return ignoredRowReasonKey(row.reason) === reasonKey;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .ignored-rows__malformed {
    margin-bottom: 1rem;
  }
</style>
